import type { DeleteActivityType } from './typings'

export const deleteActivityTypeActionCreator = (
  payload?: string,
): DeleteActivityType => ({ type: 'activityTypes/delete', payload })
